import { DATA } from '../data';
import { UpgradeData } from '../data.type';
import { niceRounding } from '../helpers';
import { PRICE_STEP_COEFFICIENT, UPGRADE_PRICE_COEFFICIENT } from './baseData';
import { IMAGES } from './images';

export type LoungeUpgradeType = 'chance' | 'ticket_price';

export const LOUNGE_DATA = {};

export const LOUNGE_UPGRADES: {
  [k in LoungeUpgradeType]: UpgradeData;
} = {
  // from 0.2 to 1, increment 0.02
  chance: {
    icon: IMAGES.ICONS.dice,
    maxValue: 40,
    description: 'Chance that a passenger will buy a ticket',
    priceFn: (upgradeLevel, priceStep) =>
      niceRounding(500 * Math.pow(UPGRADE_PRICE_COEFFICIENT, upgradeLevel) * Math.pow(PRICE_STEP_COEFFICIENT, priceStep)),
    valueFn: (upgradeLevel) => 0.2 + upgradeLevel * 0.02,
    readableValue: (upgradeLevel) => `${Math.round(LOUNGE_UPGRADES.chance.valueFn(upgradeLevel) * 100)}%`,
  },
  // from 20 to 200, 5 increment
  ticket_price: {
    icon: IMAGES.ICONS.ticket,
    maxValue: 36,
    description: 'Lounge ticket price',
    priceFn: (upgradeLevel, priceStep) =>
      niceRounding(500 * Math.pow(UPGRADE_PRICE_COEFFICIENT, upgradeLevel) * Math.pow(PRICE_STEP_COEFFICIENT, priceStep)),
    valueFn: (upgradeLevel) => Math.round((20 + upgradeLevel * 5) * DATA.currentAdvanceData.multiplier),
    readableValue: (upgradeLevel) => `$${LOUNGE_UPGRADES.ticket_price.valueFn(upgradeLevel)}`,
  },
};
